module.exports = __webpack_public_path__ + "static/guardian_wall-8b02d4bba8f142f6a578578820e95b93.jpg";